import { render } from "./AboutS7.vue?vue&type=template&id=69224c8e&scoped=true"
import script from "./AboutS7.vue?vue&type=script&lang=js"
export * from "./AboutS7.vue?vue&type=script&lang=js"

import "./AboutS7.vue?vue&type=style&index=0&id=69224c8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69224c8e"]])

export default __exports__